import { theme } from "antd";

const anttheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#FFFFFF",
    controlOutline: "#0C0B0B",
    colorSplit: '#BDBDBD'
  },
};

export default anttheme;
